import React from "react";
import {connect} from "react-redux";
import MyTheme from "../../Theme/Theme";
import {View, Dimensions, Animated, Keyboard, ScrollView, TouchableOpacity, Text, Image} from "react-native";
import Tabs from "../Menu/Tabs";
import {getLastContent,getMyFocus} from "../../API/api-static";
import PostList from "../Feed/PostFeed/PostList";
import FiltrePicto from "../Picto/FiltrePicto";
import OfflinePicto from "../Picto/OfflinePicto";
import AvatarIcon from "../Header/AvatarIcon";
import {getBookmark, getFeedFocus, getFeedNormal, setBookmark} from "../../API/API";
import {useTranslation, withTranslation} from "react-i18next";
import {compose} from "redux";
import Logo, {BOLogo} from "../Picto/Logo";



class FeedScreen extends React.Component{

    constructor(props) {
        super(props);
        this.setActiveTab = this.setActiveTab.bind(this);
        this.getFeedNormal = this.getFeedNormal.bind(this);
        this.getFeedFocus = this.getFeedFocus.bind(this);

        this.loadMoreNormal = this.loadMoreNormal.bind(this);
        this.loadMoreFocus = this.loadMoreFocus.bind(this);
        this.resetFocus = this.resetFocus.bind(this);
        this.resetFeed = this.resetFeed.bind(this);
        this.navigateToFocusScreen = this.navigateToFocusScreen.bind(this);
        this.mref =React.createRef();

        const lastContent = this._getLastPost();
        const myFocus = this._getMyFocus();
        const feeds = {
            LastContent:
                {
                    Title :'Derniers Contenus',
                    Image: 'https://www.wikichat.fr/wp-content/uploads/sites/2/comment-soigner-une-plaie-dun-chat.jpg',
                    Feed: [],
                    refresh : this._getLastPost,
                    loadMore : this.loadMoreNormal
                }
            ,
            MyFocus:
                {
                    Title : 'Mes focus',
                    Image: 'https://static.actu.fr/uploads/2020/08/25405-200804150844750-0.jpg',
                    Feed :[],
                    refresh : this._getMyFocus,
                    loadMore : this.loadMoreFocus
                }
        };

        this.data = Object.keys(feeds).map((i) => ({
            key: i,
            title: feeds[i].Title,
            image: feeds[i].Image,
            feed : feeds[i].Feed,
            refresh : feeds[i].refresh,
            ref : React.createRef()
        }));

        this.feeds = feeds;
        this.state = {
            scrollX: new Animated.Value(0),
            activeTab : 0,
            data : this.data,
            lastContent : lastContent,
            currentCursor : undefined,
            nextCursor : undefined,
            currentCursorFocus : undefined,
            nextCursorFocus : undefined,
            myFocus : myFocus,
            isRefresh  : false,
            isLoading : true,
            bookmark:[]
        }
        this.getBookmark();
        this.getFeedNormal();
        this.getFeedFocus();
    }


    componentDidUpdate() {
        this._setHeader(this.state.activeTab);
    }

    getDimensions() {
      return Dimensions.get('window');
    }

    onItemPress = (itemIndex) => {
        Keyboard.dismiss();

        const { width } = this.getDimensions();
        this.mref.current.scrollToOffset({
            offset : itemIndex * width
        });
    }

    setActiveTab(){
        const { width } = this.getDimensions();
        let activeTab = Math.round(this.state.scrollX._value/width);
        this._setHeader(activeTab);
        this.setState({ activeTab });
        Keyboard.dismiss();
    }

    _setHeader(activeTab) {

        if (activeTab == 0) {
            this._setHeaderLogoCompte();
        }else{
            this._setHeaderLogoCompteOption();
        }
    }

    _setHeaderLogoCompte(){
        const styleHeaderGlobal = {
            shadowOpacity: 0,
            shadowRadius: 0,
            borderWidth:0,
            elevation: 0,
            borderColor:"transparent" ,
            borderBottomWidth:0,
            backgroundColor : this.props.theme.colors.tertiary.grey3.value,
            height:80
        }  ;

        this.props.navigation.setOptions({
            headerRight : ()=>{
                return <View>{
                  !navigator.onLine &&
                  <OfflinePicto isHeader={true} style={{marginRight: "20px", width: 35, height: 35}} />
                }</View>
            },
            headerTitle: () => (<View style={{flexDirection:'row',gap:10}}><Logo /><BOLogo /></View> ),
            headerStyle: styleHeaderGlobal,
            headerTitleAlign: "center",
            cardStyle: { backgroundColor: this.props.theme.colors.tertiary.grey3.value},
            headerLeft : ()=>
                <TouchableOpacity
                    onPress={()=>{this.props.navigation.navigate('MyProfil',{})} }>
                    <AvatarIcon style={{width:35,height:35,borderWidth:0,borderRadius:14}}  isHeader={true} icon={this.props.auth.compte.img}/>
                </TouchableOpacity>
            , });
    }

    _setHeaderLogoCompteOption(){

        const styleHeaderGlobal = {
            shadowOpacity: 0,
            shadowRadius: 0,
            borderWidth:0,
            elevation: 0,
            borderColor:"transparent" ,
            borderBottomWidth:0,
            fontFamily: this.props.theme.fonts.title,
            backgroundColor : this.props.theme.colors.tertiary.grey3.value,
            height:80
        }  ;
        this.props.navigation.setOptions({
            headerRight : ()=><TouchableOpacity onPress={this.navigateToFocusScreen} ><FiltrePicto style={{width:20,height:17,flex : 1,marginRight:20 } } isHeader={true} /></TouchableOpacity>,
            headerStyle: styleHeaderGlobal,
            cardStyle: { backgroundColor: this.props.theme.colors.tertiary.grey3.value},
        });
    }

    navigateToFocusScreen(){
        this.props.navigation.navigate('MyFocus',{});
    }

    _getLastPost(){
        return getLastContent;
    }

    _getMyFocus(){
        return getMyFocus;
    }

    componentDidMount() {
        this.setState({ isLoading: true });
        this.props.navigation.addListener("focus",e=>{
            this.resetFocus();
            this.getFeedNormal();
            this.getFeedFocus();
        });
        this._setHeaderLogoCompte();
    }

    componentWillUnmount() {
    }

    loadMoreNormal(){
        this.getFeedNormal();
    }

    loadMoreFocus(){
        this.getFeedFocus();
    }

    resetFocus(){
        this.feeds.MyFocus.Feed = [];
        this.updateTab("","");
    }

    updateTab(cursor,cursorFocus){
        this.data = Object.keys(this.feeds).map((i) => ({
            key: i,
            title: this.feeds[i].Title,
            image: this.feeds[i].Image,
            feed : this.feeds[i].Feed,
            refresh : this.feeds[i].refresh,
            loadMore : this.feeds[i].loadMore,
            ref : React.createRef()
        }));
        if(cursor==""){
            cursor=this.state.currentCursor;
        }

        if(cursorFocus==""){
            cursorFocus=this.state.currentCursorFocus;
        }

        this.setState({
            currentCursor : cursor,
            currentCursorFocus:cursorFocus,
            //activeTab : width/this.state.scrollX || 0,
            data : this.data,
            isLoading: false
        });
        this.setActiveTab();
    }

    resetFeed(){

    }

    getBookmark(){
        getBookmark().then(data=>{
            this.state.bookmark = data
        });
    }

    getFeedNormal(){
        if(this.state.nextCursor!==false){
        getFeedNormal(this.state.currentCursor).then(data => {
            if(data=="Not Acceptable"){
                this._deconnexion();
                return false;
            }
            let d = this.uniqueArray(this.feeds.LastContent.Feed,data.data);
            this.feeds.LastContent.Feed = this.feeds.LastContent.Feed.concat(d) ;

                this.updateTab(data.cursor,"");
        });
        }
    }

    getFeedFocus(){
        if(this.state.nextCursorFocus!==false){
            getFeedFocus(this.state.currentCursorFocus).then(data => {
                if(data=="Not Acceptable"){
                    this._deconnexion();
                    return false;
                }
                let d = this.uniqueArray(this.feeds.MyFocus.Feed,data.data);

                this.feeds.MyFocus.Feed = this.feeds.MyFocus.Feed.concat(d) ;

                this.updateTab("",data.cursor);
            });
        }
    }

    uniqueArray(arr1,arr2){
        let ids  = arr1.map((item)=>{return item.id});
        return  arr2.filter((item) =>{return !ids.includes(item.id);});
    }

    _deconnexion(){
        const action = {'type': 'SIGN_OUT', 'value': ""};
        this.props.dispatch(action);
        this.props.navigation.navigate("Connexion",{});
    }

    render() {
        const { width, height } = this.getDimensions();

        // <UserInactivity timeForInactivity={90000} onAction={() => {const action = {'type': 'SIGN_OUT_NIP', 'value':{}};this.props.dispatch(action);}} >
        return (<View  style={{flex:1,flexDirection:"column"}}>
                <Tabs scrollX={this.state.scrollX} total_width={width} data={this.data}
                      indexActive={this.state.activeTab} onItemPressCallBack={this.setActiveTab} onItemPress={this.onItemPress}/>

                <Animated.FlatList

                    style={{marginTop:48,flex:1,height:height}}
                    ref={this.mref}
                    data={this.state.data}
                    keyExtractor={item=>item.key}
                    horizontal={true}
                    showsHorizontalScrollIndicator={false}
                    pagingEnabled={true}
                    bounces={false}
                    onScroll={Animated.event([{nativeEvent :{contentOffset:{x:this.state.scrollX}}}],{listener :(event)=>{this.setActiveTab()} ,useNativeDriver:false})}
                    renderItem={({item,index})=>{
                        if(item.feed!==undefined && item.feed.length>0 ){
                            return <PostList bookmark={this.state.bookmark} isExplorer={false} isActive={(index==this.state.activeTab)} refNavigation={this.props.navigation}
                                    route={this.props.route} isRefresh={this.state.isRefresh} loadMore={item.loadMore} refresh={item.refresh} data={item.feed} />
                        }else{
                            return <View style={{width:width,height:height,justifyContent:"center",alignItems:"center"}}><Text>Aucun élément à afficher</Text></View>
                        }
                    }}
                />
            </View>
        );
    }

}

const mapStateToProps = (state) => {
    return {isDark: state.changeTheme.isDark,theme: state.changeTheme.theme, auth : state.AuthReducer, online: state.sw_reducer.online}
}

export default compose(withTranslation(),connect(mapStateToProps))(FeedScreen);
